function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }

function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }

function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }

function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }

function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }

function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }

function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }

function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

function createNode(text) {
  var node = document.createElement('pre');
  node.style.width = '1px';
  node.style.height = '1px';
  node.style.position = 'fixed';
  node.style.top = '5px';
  node.textContent = text;
  return node;
}

function copyNode(node) {
  if ('clipboard' in navigator) {
    // eslint-disable-next-line flowtype/no-flow-fix-me-comments
    // $FlowFixMe Clipboard is not defined in Flow yet.
    return navigator.clipboard.writeText(node.textContent);
  }

  var selection = getSelection();

  if (selection == null) {
    return Promise.reject(new Error());
  }

  selection.removeAllRanges();
  var range = document.createRange();
  range.selectNodeContents(node);
  selection.addRange(range);
  document.execCommand('copy');
  selection.removeAllRanges();
  return Promise.resolve();
}

function copyText(text) {
  if ('clipboard' in navigator) {
    // eslint-disable-next-line flowtype/no-flow-fix-me-comments
    // $FlowFixMe Clipboard is not defined in Flow yet.
    return navigator.clipboard.writeText(text);
  }

  var body = document.body;

  if (!body) {
    return Promise.reject(new Error());
  }

  var node = createNode(text);
  body.appendChild(node);
  copyNode(node);
  body.removeChild(node);
  return Promise.resolve();
}

function copy(button) {
  var id = button.getAttribute('for');
  var text = button.getAttribute('value');

  function trigger() {
    button.dispatchEvent(new CustomEvent('clipboard-copy', {
      bubbles: true
    }));
  }

  if (text) {
    copyText(text).then(trigger);
  } else if (id) {
    var root = 'getRootNode' in Element.prototype ? button.getRootNode() : button.ownerDocument;
    if (!(root instanceof Document || 'ShadowRoot' in window && root instanceof ShadowRoot)) return;
    var node = root.getElementById(id);
    if (node) copyTarget(node).then(trigger);
  }
}

function copyTarget(content) {
  if (content instanceof HTMLInputElement || content instanceof HTMLTextAreaElement) {
    return copyText(content.value);
  } else if (content instanceof HTMLAnchorElement && content.hasAttribute('href')) {
    return copyText(content.href);
  } else {
    return copyNode(content);
  }
}

function clicked(event) {
  var button = event.currentTarget;

  if (button instanceof HTMLElement) {
    copy(button);
  }
}

function keydown(event) {
  if (event.key === ' ' || event.key === 'Enter') {
    var button = event.currentTarget;

    if (button instanceof HTMLElement) {
      event.preventDefault();
      copy(button);
    }
  }
}

function focused(event) {
  event.currentTarget.addEventListener('keydown', keydown);
}

function blurred(event) {
  event.currentTarget.removeEventListener('keydown', keydown);
}

var ClipboardCopyElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ClipboardCopyElement, _HTMLElement);

  var _super = _createSuper(ClipboardCopyElement);

  function ClipboardCopyElement() {
    var _this;

    _classCallCheck(this, ClipboardCopyElement);

    _this = _super.call(this);

    _this.addEventListener('click', clicked);

    _this.addEventListener('focus', focused);

    _this.addEventListener('blur', blurred);

    return _this;
  }

  _createClass(ClipboardCopyElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }
    }
  }, {
    key: "value",
    get: function get() {
      return this.getAttribute('value') || '';
    },
    set: function set(text) {
      this.setAttribute('value', text);
    }
  }]);

  return ClipboardCopyElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!window.customElements.get('clipboard-copy')) {
  window.ClipboardCopyElement = ClipboardCopyElement;
  window.customElements.define('clipboard-copy', ClipboardCopyElement);
}

export default ClipboardCopyElement;